import { Modal, Box, ToggleButtonGroup, ToggleButton, Button } from '@mui/material';

import useGlobalStyles from '../../../useGlobalStyles';
import useUsersListModalStyles from './useUsersListModalStyles';
import useUsersListModal from '../../../../hooks/useUsersListModal';
import UserInfo from '../../baseComponents/userInfo';

const UsersListModal = () => {
  const { classes } = useUsersListModalStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const { open, handleClose, currentUser, handleUsersListView, usersListView, handleUserClick } =
    useUsersListModal();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'>
      <Box className={`${globalClasses.modal} ${classes.usersListModal}`}>
        <ToggleButtonGroup
          value={usersListView}
          exclusive
          onChange={(_, value) => handleUsersListView(value)}
          aria-label='followers following toggle'
          className={classes.btns}>
          <ToggleButton value='followers' aria-label='followers' className={classes.btn}>
            Followers
          </ToggleButton>
          <ToggleButton value='following' aria-label='following' className={classes.btn}>
            Following
          </ToggleButton>
        </ToggleButtonGroup>
        <div className={classes.scrollableModalContent}>
          {usersListView === 'followers'
            ? currentUser?.followers.map(follower => (
                <Button
                  key={follower._id}
                  className={classes.userItem}
                  onClick={() => handleUserClick(follower.username)}>
                  <UserInfo
                    profilePicture={follower.profilePicture}
                    username={follower.username}
                    profilePicSize={45}
                  />
                </Button>
              ))
            : currentUser?.following.map(following => (
                <Button
                  key={following._id}
                  className={classes.userItem}
                  onClick={() => handleUserClick(following.username)}>
                  <UserInfo
                    profilePicture={following.profilePicture}
                    username={following.username}
                    profilePicSize={45}
                  />
                </Button>
              ))}
        </div>
      </Box>
    </Modal>
  );
};

export default UsersListModal;
